import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/close-white.svg'
import _imports_1 from '@/assets/images/close.svg'


const _hoisted_1 = _imports_0
const _hoisted_2 = { class: "country-select__input-wrapper" }
const _hoisted_3 = ["placeholder", "disabled", "onKeydown"]
const _hoisted_4 = {
  key: 0,
  class: "country-select__dropdown"
}
const _hoisted_5 = { class: "country-select__options" }
const _hoisted_6 = {
  key: 0,
  class: "country-select__empty"
}
const _hoisted_7 = ["onMousedown"]

import { countries, Country } from "@/models/countries"
import { getCountryName } from "@/utils/getCountryName"
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

interface CountrySelectProps {
  modelValue: string
  error?: boolean
  disabled?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CountrySelect',
  props: {
    modelValue: {},
    error: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { locale } = useI18n()

const container = ref<HTMLElement | null>(null)
const input = ref<HTMLInputElement | null>(null)
const isOpen = ref(false)
const search = ref("")
const highlightedIndex = ref(-1)

const selectedCountry = computed(() =>
  countries.find((country) => country.code === props.modelValue)
)

const getName = (country: Country) => {
  return getCountryName(country, locale.value)
}

const filteredCountries = computed(() => {
  const searchValue = search.value.trim().toLocaleLowerCase()

  if (!searchValue) {
    return countries
  }

  return countries.filter((country) => {
    const name = getName(country).toLocaleLowerCase()

    return (
      name.includes(searchValue) ||
      country.code.toLocaleLowerCase().includes(searchValue)
    )
  })
})

const open = () => {
  if (props.disabled) {
    return
  }

  isOpen.value = true
  highlightedIndex.value = -1
}

const close = () => {
  isOpen.value = false
  highlightedIndex.value = -1

  search.value = selectedCountry.value ? getName(selectedCountry.value) : ""
}

const clear = () => {
  search.value = ""
  isOpen.value = true
  highlightedIndex.value = -1

  emit("update:modelValue", "")

  nextTick(() => {
    input.value?.focus()
  })
}

const selectCountry = (country: Country) => {
  emit("update:modelValue", country.code)
  search.value = getName(country)
  close()
}

const moveDown = () => {
  if (!isOpen.value) {
    open()
    return
  }

  if (filteredCountries.value.length === 0) {
    return
  }

  highlightedIndex.value =
    highlightedIndex.value < filteredCountries.value.length - 1
      ? highlightedIndex.value + 1
      : 0
}

const moveUp = () => {
  if (!isOpen.value) {
    open()
    return
  }

  if (filteredCountries.value.length === 0) {
    return
  }

  highlightedIndex.value =
    highlightedIndex.value > 0
      ? highlightedIndex.value - 1
      : filteredCountries.value.length - 1
}

const selectHighlighted = () => {
  const country = filteredCountries.value[highlightedIndex.value]

  if (country) {
    selectCountry(country)
  }
}

const handleClickOutside = (event: MouseEvent) => {
  if (container.value && !container.value.contains(event.target as Node)) {
    close()
  }
}

watch(
  [selectedCountry, locale],
  ([country]) => {
    if (!isOpen.value) {
      search.value = country ? getName(country) : ""
    }
  },
  { immediate: true }
)

onMounted(() => {
  document.addEventListener("click", handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "country-select"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "input",
        ref: input,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        type: "text",
        class: _normalizeClass(["input country-select__input", { error: __props.error, open: isOpen.value }]),
        placeholder: _ctx.$t('registrationPage.form.country') + '*',
        disabled: __props.disabled,
        autocomplete: "off",
        onFocus: open,
        onInput: open,
        onKeydown: [
          _withKeys(close, ["esc"]),
          _withKeys(_withModifiers(moveDown, ["prevent"]), ["down"]),
          _withKeys(_withModifiers(moveUp, ["prevent"]), ["up"]),
          _withKeys(_withModifiers(selectHighlighted, ["prevent"]), ["enter"])
        ]
      }, null, 42, _hoisted_3), [
        [_vModelText, search.value]
      ]),
      (search.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "country-select__clear",
            "aria-label": "Clear country",
            onMousedown: _withModifiers(clear, ["prevent"])
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("picture", null, [
              _createElementVNode("source", {
                srcset: _hoisted_1,
                media: "(prefers-color-scheme: dark)"
              }),
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              })
            ], -1)
          ]))], 32))
        : _createCommentVNode("", true)
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (filteredCountries.value.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(_ctx.$t("registrationPage.form.noCountriesFound")), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCountries.value, (country, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: country.code,
                class: _normalizeClass(["country-select__option", {
            selected: country.code === __props.modelValue,
            highlighted: index === highlightedIndex.value
          }]),
                onMousedown: _withModifiers(($event: any) => (selectCountry(country)), ["prevent"])
              }, _toDisplayString(getName(country)), 43, _hoisted_7))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})